import { LinkedAccount, LinkedAccountPurviewLabel } from "../../../../../../models/Entities";
import { useRequest } from "../../../../../shared/hooks/useRequest";

type UseLoadLinkedAccountPurviewLabelsProps = {
  linkedAccount: LinkedAccount;
};

const useLoadLinkedAccountPurviewLabels = ({
  linkedAccount,
}: UseLoadLinkedAccountPurviewLabelsProps) => {
  // derived state
  const linkedAccountPurviewLabelsPath = `integrations/selective-sync/linked-account/${linkedAccount.id}/purview-labels`;

  const { loading: linkedAccountPurviewLabelsLoading, data: linkedAccountPurviewLabels } =
    useRequest<LinkedAccountPurviewLabel[]>({
      path: linkedAccountPurviewLabelsPath,
      errorText: "Error loading linked account purview labels",
    });

  return {
    linkedAccountPurviewLabels,
    loading: linkedAccountPurviewLabelsLoading,
  };
};

export default useLoadLinkedAccountPurviewLabels;
